module.exports = __webpack_public_path__ + "static/img/logo-pj-transparente-negro-recibo.c84e49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-pj-transparente-negro-recibo.png
// module id = 8beq
// module chunks = 2